import React from 'react';
import { Sun, MoonStar } from 'lucide-react';

export const KeepAwakeToggle = ({ keepAwake, onToggle, className = '', style, testId }) => (
  <button
    onClick={onToggle}
    className={`flex items-center gap-2 whitespace-nowrap transition-all ${className}`}
    style={style}
    title={keepAwake
      ? "L'écran reste allumé pendant la séance — toucher pour autoriser la veille"
      : "L'écran peut se mettre en veille, la séance continue — toucher pour garder l'écran allumé"}
    data-testid={testId}
  >
    {keepAwake ? <Sun className="w-4 h-4 text-amber-300" /> : <MoonStar className="w-4 h-4" />}
    <span>{keepAwake ? 'Écran allumé' : 'Veille auto'}</span>
  </button>
);

export default KeepAwakeToggle;
